// Șabloane native de documente (SoW 2.1) — elimină "sindromul foii albe":
// fiecare nivel al ierarhiei are secțiuni obligatorii predefinite, randate
// dinamic în DocumentForm pe baza acestei configurații.

export const LEVELS = [
  { value: "POLITICA", label: "Politică", scurt: "POL" },
  { value: "STANDARD", label: "Standard", scurt: "STD" },
  { value: "PROCEDURA", label: "Procedură (SOP)", scurt: "SOP" },
  { value: "INSTRUCTIUNE", label: "Instrucțiune de Lucru", scurt: "WI" },
];

export const LEVEL_LABEL = Object.fromEntries(LEVELS.map((l) => [l.value, l.label]));

export const PARENT_LEVEL = {
  POLITICA: null,
  STANDARD: "POLITICA",
  PROCEDURA: "STANDARD",
  INSTRUCTIUNE: "PROCEDURA",
};

// Cele 7 funcții predefinite din SoW 3.5 — folosite atât în matricea RACI
// a Procedurilor (text liber), cât și în modulul de Instruire și Evaluare
// (FUNCTIE_ROL_OPTIONS de mai jos — enum validat de backend, aceeași
// ordine/etichete, vezi backend/src/common/constants/functii.ts).
export const FUNCTII_PREDEFINITE = [
  "Agent Securitate",
  "Recepție Persoane",
  "Dispecer",
  "Șef Tură Securitate",
  "Manager Dispecerat",
  "Șef Obiectiv",
  "Manager Securitate",
];

export const FUNCTIE_ROL_OPTIONS = [
  { value: "AGENT_SECURITATE", label: "Agent Securitate" },
  { value: "RECEPTIE_PERSOANE", label: "Recepție Persoane" },
  { value: "DISPECER", label: "Dispecer" },
  { value: "SEF_TURA_SECURITATE", label: "Șef Tură Securitate" },
  { value: "MANAGER_DISPECERAT", label: "Manager Dispecerat" },
  { value: "SEF_OBIECTIV", label: "Șef Obiectiv" },
  { value: "MANAGER_SECURITATE", label: "Manager Securitate" },
];

export const TEMPLATES = {
  POLITICA: [
    { key: "declaratieIntentie", label: "Declarație de intenție", type: "textarea" },
    { key: "aplicabilitateGlobala", label: "Aplicabilitate globală", type: "textarea" },
    { key: "responsabilitatiExecutive", label: "Responsabilități executive", type: "textarea" },
  ],
  STANDARD: [
    { key: "introducere", label: "Introducere", type: "textarea" },
    { key: "scopAplicabilitate", label: "Scop și aplicabilitate (ariile de operațiuni acoperite)", type: "textarea" },
    { key: "documenteReferinta", label: "Documente de referință", type: "list" },
    { key: "termeniDefinitii", label: "Termeni și definiții", type: "definitions" },
    { key: "roluriResponsabilitati", label: "Roluri și responsabilități (cine aprobă, cine implementează, cine verifică)", type: "roles" },
    { key: "sanctiuni", label: "Sancțiuni pentru nerespectare", type: "textarea" },
  ],
  PROCEDURA: [
    { key: "obiectiv", label: "Obiectiv (ce problemă sau proces specific reglementează)", type: "textarea" },
    { key: "descriereProces", label: "Descrierea procesului", type: "textarea" },
    { key: "gestionareExceptii", label: "Gestionarea excepțiilor", type: "textarea" },
    { key: "documenteReferinta", label: "Documente de referință", type: "list" },
    { key: "eficienta", label: "Cum se măsoară eficiența procedurii", type: "textarea" },
    { key: "raci", label: "Responsabilități pe funcții (Matrice RACI)", type: "raci" },
    { key: "anexeFormulare", label: "Anexe și formulare", type: "list" },
    { key: "sanctiuni", label: "Sancțiuni pentru nerespectare", type: "textarea" },
  ],
  INSTRUCTIUNE: [
    { key: "pasiOperationali", label: "Pași operaționali (Checklist)", type: "list" },
    { key: "actiuniUrgenta", label: "Acțiuni de urgență", type: "textarea" },
    { key: "numereContactPost", label: "Numere de contact post", type: "list" },
  ],
};

export function continutImplicit(level) {
  const fields = TEMPLATES[level] || [];
  const content = {};
  for (const f of fields) {
    if (f.type === "list" || f.type === "raci" || f.type === "definitions" || f.type === "roles") content[f.key] = [];
    else content[f.key] = "";
  }
  return content;
}

export const STATUS_LABEL = {
  DRAFT: "Ciornă",
  IN_ASTEPTARE_APROBARE: "În Așteptare Aprobare",
  IN_ASTEPTARE_CLIENT: "În Așteptare Co-Validare Client",
  APROBAT: "Aprobat",
  RESPINS: "Respins",
  ARHIVAT: "Arhivat",
};

export const STATUS_CLASS = {
  DRAFT: "status-draft",
  IN_ASTEPTARE_APROBARE: "status-pending",
  IN_ASTEPTARE_CLIENT: "status-pending",
  APROBAT: "status-approved",
  RESPINS: "status-rejected",
  ARHIVAT: "status-archived",
};

export const ROLE_LABEL = {
  OWNER: "Owner",
  EDITOR: "Editor",
  APPROVER: "Aprobator",
  CLIENT_REVIEWER: "Reprezentant Client",
};
